import { action, observable, computed } from 'mobx'
import get from 'lodash/get'
import unionBy from 'lodash/unionBy'

import { BlockModel } from '@client/components/Block/model'
import { defaultSettings } from './constants'
import { BLOCK_TYPES, MIN_WIDTH } from '@client/components/Block/constants'

export default class FormModel extends BlockModel {
  constructor(data = {}, editor) {
    super(data)

    this.editor = editor

    this.type = BLOCK_TYPES.FORM

    const { button, ...rest } = defaultSettings

    const fieldsData = get(data, 'settings.fields', [])

    const mergedFields = unionBy(fieldsData, defaultSettings.fields, 'name')

    const fields = mergedFields.map((item) => {
      return {
        ...item,
        defaultLabel: item.defaultLabel ? item.defaultLabel : item.label,
      }
    })

    this.settings.set({
      ...rest,
      ...{
        button: {
          text: defaultSettings.button.text,
        },
      },
      ...(get(data, 'settings') || {}),
      fields: fields,
    })
  }

  @observable containerDimensions = { width: 0, height: 0 }

  @action setContainerDimensions = (obj) => {
    if (!obj || (obj && !obj.width) || (obj && obj.width < MIN_WIDTH)) {
      return
    }
    this.containerDimensions = obj
    if (
      this.editor?.viewMode !== 'mobile' &&
      this.settings.values.width > obj.width &&
      obj.width >= MIN_WIDTH
    ) {
      // As a string: that is what every stored payload holds and what the
      // other blocks write, so a number here would flip the type and dirty
      // the document on first measurement. FE-1359.
      this.settings.set({ width: obj.width.toString() })
    }
  }

  @computed get allColors() {
    const s = this.settings.values
    const colors = [
      s.backgroundColor,
      s.borderColor,
      s.textColor,
      s.fields_background,
      s.fields_color,
      s.fields_borderColor,
      s?.button?.backgroundColor,
      s?.button?.textColor,
    ]

    return Array.from(new Set(colors.filter(Boolean)))
  }

  serialize = () => {
    const settings = this.settings.serialize()
    settings.fields = settings.fields
      .filter((item) => item.default || !item.disabled)
      .map((item) => {
        if (item.name === 'email') {
          return {
            ...item,
            disabled: false,
            required: true,
          }
        }
        return item
      })
    return {
      type: this.type,
      settings: settings,
    }
  }
}

export const NULL = new FormModel()
